import Vue from "vue";

import "./styles/quasar.scss";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/fontawesome-v5/fontawesome-v5.css";
import { Quasar, Dialog, QForm, Notify } from "quasar";

Vue.use(Quasar, {
  config: {},
  components: {
    QForm

    /* not needed if importStrategy is not 'manual' */
  },
  directives: {
    /* not needed if importStrategy is not 'manual' */
  },
  plugins: {
    Dialog,
    Notify
  }
});
